import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import OfferingsPage from './pages/OfferingsPage';
import ProductsPage from './pages/ProductsPage';
import EventsPage from './pages/EventsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import CookiesPage from './pages/CookiesPage';
import DisclaimerPage from './pages/DisclaimerPage';
import ShippingPage from './pages/ShippingPage';
import InvestorsPage from './pages/InvestorsPage';
import InvestorDashboard from './pages/InvestorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminLoginPage from './pages/AdminLoginPage';
import HRLoginPage from './pages/HRLoginPage';
import HRAdminPortal from './pages/HRAdminPortal';
import EmployeePortal from './pages/EmployeePortal';
import AcceptOfferPage from './pages/AcceptOfferPage';
import SalesAdminPortal from './pages/SalesAdminPortal';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/offerings" element={<OfferingsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/investors" element={<InvestorsPage />} />
          <Route path="/investor/dashboard" element={<InvestorDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          {/* Combined Admin Login Page */}
          <Route path="/admin" element={<AdminLoginPage />} />
          {/* Sales Admin Portal */}
          <Route path="/sales/admin" element={<SalesAdminPortal />} />
          {/* HR Portal Routes */}
          <Route path="/hr/login" element={<HRLoginPage />} />
          <Route path="/employee/login" element={<HRLoginPage />} />
          <Route path="/hr/admin" element={<HRAdminPortal />} />
          <Route path="/employee/portal" element={<EmployeePortal />} />
          <Route path="/employee/accept-offer/:token" element={<AcceptOfferPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
